var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.19498 2H17.167C20.5849 2 23.362 4.77706 23.362 8.19498V17.167C23.362 20.5884 20.5884 23.362 17.167 23.362H8.19498C4.77706 23.362 2 20.5849 2 17.167V8.19498C2 4.77359 4.77359 2 8.19498 2ZM7.98142 4.135C5.85779 4.135 4.13626 5.85653 4.13626 7.98016V17.3794C4.13626 19.505 5.8559 21.2246 7.98142 21.2246H17.3807C19.5043 21.2246 21.2259 19.5031 21.2259 17.3794V7.98016C21.2259 5.85464 19.5062 4.135 17.3807 4.135H7.98142ZM19.6237 7.07227C19.6237 6.3349 19.026 5.73715 18.2886 5.73715C17.5512 5.73715 16.9535 6.3349 16.9535 7.07227C16.9535 7.80964 17.5512 8.4074 18.2886 8.4074C19.026 8.4074 19.6237 7.80964 19.6237 7.07227ZM12.6811 7.3393C15.6305 7.3393 18.0216 9.73032 18.0216 12.6798C18.0216 15.6293 15.6305 18.0203 12.6811 18.0203C9.73158 18.0203 7.34056 15.6293 7.34056 12.6798C7.34056 9.73032 9.73158 7.3393 12.6811 7.3393ZM9.47624 12.6808C9.47624 10.9112 10.9109 9.47654 12.6805 9.47654C14.4502 9.47654 15.8848 10.9112 15.8848 12.6808C15.8848 14.4505 14.4502 15.8851 12.6805 15.8851C10.9109 15.8851 9.47624 14.4505 9.47624 12.6808Z",
    fill: "#9096F6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.4603430ad5df90ddf57914327ff827a2.svg";
export { ForwardRef as ReactComponent };